module.exports = __webpack_public_path__ + "static/media/icon-hospital.2ab83b86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-hospital.svg
// module id = 100
// module chunks = 0